import axios from "axios";
import baseServices from "./base.service";

const list = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_list.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
const listFront = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_list_front.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
const get = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_get.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
const getFront = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_get_front.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const submit = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_submit.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const remove = (params) => {
  return new Promise((resolve, reject) => {
    baseServices
      .post("/rental_delete.php", params)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const rentalService = {
  list,
  get,
  submit,
  remove,
  listFront,
  getFront,
};

export default rentalService;
